import React, { useContext } from "react";
import * as Tooltip from "react-tooltip";
import AppContext from "../../../AppContext.jsx";
import { langComponent } from "../../../constants/index.jsx";
import {
  formatNumber,
  numberToOrdinal,
} from "../../../helpers/common.helper.js";
import { useNavigate } from "react-router-dom";
import TenderingDetailContext from "../../../pages/TenderingPage/context.jsx";

const Items = () => {
  const { paymentTerms } = useContext(TenderingDetailContext);

  const { getLang } = useContext(AppContext);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  const _getPayments = () => {
    const _payments = [];

    for (let i = 0; i < paymentTerms.length; i++) {
      if (!paymentTerms[0].paid && _payments.length === 2) break;
      if (paymentTerms[0].paid && _payments.length === 1) break;

      const payment = paymentTerms[i];

      if (!payment.paid) {
        let termName = "Final";

        if (i === 0) {
          termName = "Advanced";
        }

        if (i < paymentTerms.length - 2) {
          termName = numberToOrdinal(i);
        }

        _payments.push({
          ...payment,
          termNo: i,
          termName: termName + " payment",
        });
      }
    }

    return _payments;
  };

  return (
    <div className="tendering-cart-content-items">
      <div className="tendering-cart-content-items-header">
        <div className="tendering-cart-content-items-header__title">
          {TranslationWorkExchange("Cart")}
        </div>
      </div>
      <div className="tendering-cart-content-items-list">
        {_getPayments().map((pt) => {
          return (
            <div className="tendering-cart-content-items-list__payment">
              <span>{pt.termName}</span>
              <span>{formatNumber(pt.total ?? pt.subTotal)}</span>
            </div>
          );
        })}
      </div>
      <Tooltip.Tooltip id="tooltip-shopping" />
    </div>
  );
};

Items.propTypes = {};

export default Items;
